import * as swcHelpers from '@swc/helpers';

const STORAGE_KEY = 'created-appointments';
const getStoredAppointment = (id)=>{
    const isClient = typeof window !== 'undefined';
    if (!id || !isClient) {
        return null;
    }
    var ref;
    const json = (ref = window.sessionStorage.getItem(STORAGE_KEY)) !== null && ref !== void 0 ? ref : '{}';
    const appointments = JSON.parse(json);
    var _id;
    const appointment = (_id = appointments[id]) !== null && _id !== void 0 ? _id : null;
    return appointment ? swcHelpers.objectSpread({}, appointment, {
        startTime: new Date(appointment.startTime),
        endTime: new Date(appointment.endTime)
    }) : null;
};
const setStoredAppointment = (appointment)=>{
    const isClient = typeof window !== 'undefined';
    if (!isClient) {
        return false;
    }
    var ref;
    const json = (ref = window.sessionStorage.getItem(STORAGE_KEY)) !== null && ref !== void 0 ? ref : '{}';
    const appointments = JSON.parse(json);
    appointments[appointment.id] = appointment;
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(appointments));
    return true;
};

export { getStoredAppointment, setStoredAppointment };
//# sourceMappingURL=book-appointment-storage.js.map
